export type ReferenceListFilters = Readonly<{
  byUserID: string | undefined
  organizationIds: readonly string[]
  isCustomProperty: boolean
  hideDefaultRefs: boolean
}>

const referencesBaseKey = ['references'] as const

export const referenceKeys = {
  all: () => referencesBaseKey,

  list: (filters: ReferenceListFilters) =>
    [
      ...referencesBaseKey,
      filters.byUserID,
      filters.organizationIds,
      filters.isCustomProperty,
      filters.hideDefaultRefs,
    ] as const,
}
